import React from "react";

import { __globalModalContext } from "~/ui/modals";

import PaidFeatureModal from "./PaidFeatureModal";
import type { FeatureValues } from "./utils";

export { UpgradeIcon, default as BillingIdentity, useBillingPaywall } from "./BillingIdentity";
export { default as NoteAndFeedbackHistoryPaywall } from "./NoteAndFeedbackHistoryPaywall";

export function showFeatureModal(feature: FeatureValues) {
	__globalModalContext?.open(({ close }) => <PaidFeatureModal close={close} id={feature} />);
}

// @ts-ignore
window.showFeatureModal = showFeatureModal;
